(() => {
  const selectors = [
    '.cart__item-title',
    '.cart__item-title *',
    '.cart__item--variants',
    '.cart__item--variants *',
    '.cart__item-sub',
    '.cart__item-sub *',
    '.cart__remove',
    '.cart__remove *',
    '.cart__price',
    '.cart__price *',
    '.cart__subtotal',
    '.cart__subtotal *'
  ];
  function applyFont(root = document) {
    root.querySelectorAll(selectors.join(',')).forEach((element) => {
      element.style.setProperty('font-family', "'Eczar', serif", 'important');
    });
  }
  function schedule() {
    requestAnimationFrame(() => applyFont());
  }
  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('load', schedule);
  document.addEventListener('click', () => setTimeout(schedule, 50), true);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  schedule();
})();
